<template>
  <div class="bg-gray">
    <div class="box-content">
      <div class="apply-detail-steps-wrap">
        <el-steps :active="active" direction="vertical" class="apply-detail-steps">
          <!-- 1 联系人 -->
          <el-step :title="$T('填写秩序册')" :description="$T('联系人、邮箱与电话')">
            <div slot="description">
              <p class="desc">{{ $T('联系人、邮箱与电话') }}</p>
              <el-button size="small" round v-rblink.replace="{name:'ISaiApplyFormStep1',query:{id:row.id}}" v-if="row.memberstatus>0&&row.memberstatus<6">{{ $T('修改信息') }}</el-button>
            </div>
          </el-step>

          <!-- 2 人员 -->
          <el-step :title="$T('人员信息')" :description="$T('队伍成员与证件')">
            <div slot="description">
              <p class="desc">{{ $T('队伍成员与证件') }}</p>
              <el-button size="small" round v-rblink.replace="{name:'ISaiApplyFormStep2',query:{id:row.id}}" v-if="row.memberstatus>1&&row.memberstatus<6">{{ $T('修改信息') }}</el-button>
              <el-button size="small" round v-rblink="{name:'ISaiApplyFormStep2',query:{id:row.id}}" v-if="row.memberstatus==1" type="primary">{{ $T('继续操作') }}</el-button>
            </div>
          </el-step>

          <!-- 3 住宿 -->
          <el-step :title="$T('住宿预订')" :description="hasRoomStep ? $T('酒店与房型') : $T('线上赛区无需填写')">
            <div slot="description">
              <p class="desc">{{ hasRoomStep ? $T('酒店与房型') : $T('线上赛区无需填写') }}</p>
              <template v-if="hasRoomStep">
                <el-button size="small" round v-rblink="{name:'ISaiApplyFormStep3',query:{id:row.id}}" v-if="row.memberstatus>1&&row.memberstatus<6">{{ $T('修改信息') }}</el-button>
                <el-button size="small" round v-rblink="{name:'ISaiApplyFormStep3',query:{id:row.id}}" v-if="row.memberstatus==1" type="primary">{{ $T('继续操作') }}</el-button>
              </template>
            </div>
          </el-step>

          <!-- 4 餐饮 -->
          <el-step :title="$T('餐饮预订')" :description="$T('用餐与套餐')">
            <div slot="description">
              <p class="desc">{{ $T('用餐与套餐') }}</p>
              <el-button size="small" round v-rblink="{name:'ISaiApplyFormStep4',query:{id:row.id}}" v-if="row.memberstatus>2&&row.memberstatus<6">{{ $T('修改信息') }}</el-button>
              <el-button size="small" round v-rblink="{name:'ISaiApplyFormStep4',query:{id:row.id}}" v-if="mealShowContinue" type="primary">{{ $T('继续操作') }}</el-button>
            </div>
          </el-step>

          <!-- 5 接送 -->
          <el-step :title="$T('接送服务')" :description="$T('接机/送站')">
            <div slot="description">
              <p class="desc">{{ $T('接机/送站') }}</p>
              <el-button size="small" round v-rblink="{name:'ISaiApplyFormStep5',query:{id:row.id}}" v-if="row.memberstatus>=4&&row.memberstatus<6">{{ $T('修改信息') }}</el-button>
              <el-button size="small" round v-rblink="{name:'ISaiApplyFormStep5',query:{id:row.id}}" v-if="row.memberstatus>=2&&row.memberstatus<4" type="primary">{{ $T('继续操作') }}</el-button>
            </div>
          </el-step>

          <!-- 6 签证 -->
          <el-step :title="$T('签证邀请')" :description="$T('签证信息填报')">
            <div slot="description">
              <p class="desc">{{ $T('签证信息填报') }}</p>
              <el-button size="small" round v-rblink="{name:'ISaiApplyFormStep6',query:{id:row.id}}" v-if="row.memberstatus>=5&&row.memberstatus<5">{{ $T('修改信息') }}</el-button>
              <el-button size="small" round v-rblink="{name:'ISaiApplyFormStep6',query:{id:row.id}}" v-if="row.memberstatus>=2&&row.memberstatus<5" type="primary">{{ $T('继续操作') }}</el-button>
            </div>
          </el-step>

          <!-- 7 国歌 -->
          <el-step :title="$T('国歌上传')" :description="$T('队伍国歌音频')">
            <div slot="description">
              <p class="desc">{{ $T('队伍国歌音频') }}</p>
              <el-button size="small" round v-rblink="{name:'ISaiApplyFormStep7',query:{id:row.id}}" v-if="row.memberstatus>=5&&row.memberstatus<5">{{ $T('修改信息') }}</el-button>
              <el-button size="small" round v-rblink="{name:'ISaiApplyFormStep7',query:{id:row.id}}" v-if="row.memberstatus>=2&&row.memberstatus<5" type="primary">{{ $T('继续操作') }}</el-button>
            </div>
          </el-step>

          <!-- 8 完成 / 视频 -->
          <el-step :title="$T('报名完成')" :description="$T('报名与后续事项')">
            <div slot="description">
              <p class="desc">{{ $T('报名与后续事项') }}</p>
              <!-- <el-button size="small" round v-rblink="{name:'ISaiApplyVideoList',query:{id:row.id}}" v-if="row.memberstatus==6 && row.saiqu.need_video==1 && !row.video_ok">{{ $T('上传视频') }}</el-button> -->
              <!-- <el-button size="small" round v-rblink="{name:'ISaiApplyVideoList',query:{id:row.id}}" v-if="row.memberstatus==6 && row.saiqu.need_video==1 && row.video_ok">{{ $T('视频已上传') }}</el-button> -->
            </div>
          </el-step>
        </el-steps>
      </div>
    </div>
  </div>
</template>
<style scoped>
.apply-detail-steps-wrap {
  margin-top: 40px;
  padding: 16px 12px 24px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

.apply-detail-steps {
  max-width: 560px;
}

.apply-detail-steps >>> .el-step__title {
  font-size: 15px;
  line-height: 1.4;
}

.apply-detail-steps >>> .el-step__description {
  padding-right: 8px;
}

/* 竖向步骤：加大每步间距；连接线需延伸进底部留白，否则会「断线」 */
.apply-detail-steps >>> .el-step__head {
  overflow: visible;
}

.apply-detail-steps >>> .el-step:not(:last-child) {
  padding-bottom: 36px;
  margin-bottom: 0;
}

.apply-detail-steps >>> .el-step:not(:last-child) .el-step__line {
  top: 0;
  bottom: -36px !important;
  height: auto !important;
}

.apply-detail-steps >>> .el-step:last-child {
  padding-bottom: 8px;
}

.step-warp {
  margin: 0.2rem;
  border-radius: 0.2rem;
  padding: 0.2rem;
  background: #fff;
}

.step-warp .step-li {
  color: #000;
  position: relative;
}

.step-warp .step-li .title {
  font-size: 14px;
}

.step-warp .step-li .desc {
  margin-top: 0.2rem;
  font-size: 12px;
  color: #666;
}

.step-warp .right {
  position: absolute;
  top: 0;
  right: 0;
}

.danwei-warp {
  background: #fff;
  box-shadow: 0px 0px 10px 0px rgba(204, 204, 204, 0.5);
  border-radius: 0.2rem;
  padding: 0.2rem;
}

.danwei-warp .title {
  font-size: 18px;
  color: #000;
  margin: 10px;
  font-weight: bold;
}

.danwei-warp .saiqu {
  font-size: 14px;
  margin: 10px;
  color: #666;
}

.danwei-warp .duiwu {
  font-size: 12px;
  margin: 10px;
  color: #999;
}

.van-tag {
  width: 55px;
  margin-left: 10px;
  text-align: center;
}

.between {
  justify-content: space-between;
}

.box-content >>> .desc {
  margin: 6px 0 8px;
  font-size: 12px;
  color: #666;
}
</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';

import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  Steps,
  Step,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button
} from 'vant';
import CaipanPicker from '@/components/picker/CaipanPicker.vue';
import JiaolianPicker from '@/components/picker/JiaolianPicker.vue';

Vue.use(Cell).use(CellGroup).use(Steps).use(Step).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'SaiApplyDetail',
  components: {
    [Field.name]: Field,
    PicUploader,
    CaipanPicker,
    JiaolianPicker,
  },
  data: function () {
    return {
      validator,
      saveLoading: false,
      saiqu_id: this.$route.query.saiqu_id,
      showCaipanPicker: false,
      showJiaolianPicker: false,
      showNumTypePicker: false,
      numTypeColumns: ['身份证', '护照'],
      showArea: false,
      areaList: {},
      areaValue: '',
      submitType: '',
      row: {
        id: 0,
        saiqu_name: '',
        numTypeName: '身份证',
        danwei: '',
        memberstatus: 0,
        ldcardtype: 1,
        ldsex: 1,
        saiqu: {},
        heying: [{
          name: "选择商户.png",
          save_name: "h5/2020-05-11/1589187988243621.png",
          uid: "vc-upload-1589187988243621",
          url: "https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-05-11/1589187988243621.png"
        }],
        caipan: [],
        jiaolian: [],
      },
    }
  },
  filters: {},
  computed: {
    /** 是否线下赛区（显示住宿表单） */
    hasRoomStep() {
      return this.row.saiqu && Number(this.row.saiqu.is_online) === 2;
    },
    /** 餐饮「继续」：无住宿时与项目同为 2；有住宿时保存住宿后为 3 */
    mealShowContinue() {
      const ms = Number(this.row.memberstatus) || 0;
      if (this.hasRoomStep) {
        return ms === 3;
      }
      return ms === 2;
    },
    /**
     * el-steps 当前步（0 起，共 8 步）。
     * memberstatus：1 秩序册；2 项目；roomSave→3；mealSave→4；order→5；支付完成→6。
     */
    active() {
      const ms = Number(this.row.memberstatus) || 0;
      if (ms >= 6) {
        return 7;
      }
      if (ms === 5) {
        return 7;
      }
      if (ms === 4) {
        return 4;
      }
      if (ms === 3) {
        return 3;
      }
      if (ms === 2) {
        return this.hasRoomStep ? 2 : 3;
      }
      if (ms === 1) {
        return 1;
      }
      return 0;
    },
  },
  mounted() {
    let that = this;
    that.areaList = area;
    that.row.id = this.$route.query.id;
    that.fetch();
  },
  watch: {},
  destroyed() {
  },
  methods: {
    fetch() {
      let that = this;
      that.$api.get('/api/sai/stepDetail', {
        id: that.row.id,
      }, (res) => {
        that.row = Object.assign(that.row, res.data)
        console.log(that.row)
      })
    },
    onQuestion() {
      console.log('onQuestion')
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    },
    submit(values) {
      this.submitType = 'submit';
    },

  }
}
</script>



// WEBPACK FOOTER //
// SaiApplyDetail.vue?a780dc14